// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchWrapper_root__3ILGw","wrapper":"SearchWrapper_wrapper__PBWUy","wrapperOpen":"SearchWrapper_wrapperOpen__1uVZQ"};